import { tracked } from '@glimmer/tracking';

export class ActiveItemCache {
  @tracked _cache = { default: undefined };
  key;

  set(value, key = 'default') {
    Object.keys(this._cache).forEach((k) => {
      if (k != key) this._cache[k] = undefined;
    });
    this._cache[key] = value;

    // trigger an update
    // eslint-disable-next-line no-self-assign
    this._cache = this._cache;
  }

  get(key = 'default') {
    return this._cache[key];
  }
}
